import { Id, IMap } from './common'

export enum StationUserGoinZoneType {
  SERVICE_ZONE = 'Service',
  PICKUP = 'Pickup',
  DROPOFF = 'Dropoff'
}

export enum StationUserGoinZoneShapeType {
  SHAPE_POLYGON = 'shape_polygon',
  SHAPE_CIRCLE = 'shape_circle',
  SHAPE_MULTIPOLYGON = 'shape_multipolygon',
  SHAPE_POINT = 'shape_point'
}

export enum StationUserGeoJsonShapeType {
  SHAPE_POLYGON = 'Polygon',
  SHAPE_CIRCLE = 'Circle',
  SHAPE_MULTIPOLYGON = 'MultiPolygon',
  SHAPE_POINT = 'Point'
}

export interface IStationUserFilters {
  orgId?: string
  skip?: number
  take?: number
  isActive?: boolean
  isArchived?: boolean
  search?: string
  sortBy?: string[]
}

export interface IStationUserUpdateDTO {
  id: string
  username: string
  email: string
  firstName: string
  lastName: string
  phoneNumber: string
  countryCode: string
  organizationId: string
}
export interface IStationUserInvite {
  organizationId: string
  email: string
  username: string
  firstName: string
  lastName: string
  phoneNumber: string
  countryCode: string
}
export interface IStationUserUpdate {
  organizationId?: string
  email?: string
  username?: string
  firstName?: string
  lastName?: string
  phoneNumber?: string
}
export interface IStationUser {
  id: Id
  userId: Id
  username: string
  name: string
  phoneNumber: string
  email: string
  status: string
  isArchived?: boolean
  archivedDate?: Date
  organizationId?: string
}

export interface IStationUserSearchObject {
  id: string
  userId: string
  isArchived: boolean
  isActive: boolean
  status: string
  name: string
  firstName: string
  lastName: string
  phone: string
  countryCode: string
  email: string
  birthDate: string
  username: string
  organizationId: string
  organizationName: string
}
export interface IStationUserMenuStep {
  name: string
  url: string
  title: string
  required: boolean
  completed: boolean
}
export interface IStationUserMenuStepData {
  position: number
  fetching: boolean
  fetchingError: string
  updating: boolean
  updatingError: string
  changed: boolean
}

export interface IStationUserMenuSteps {
  list: IStationUserMenuStep[]
  currentStep: IStationUserMenuStepData
}

export interface IStationUserZoneObject {
  id?: string
  stationUserId: string
  name: string
  address?: string
  description?: string
  color: string
  type: StationUserGoinZoneType
  shapeType: StationUserGoinZoneShapeType | StationUserGeoJsonShapeType
  radius?: number
  center?: {
    type: string
    coordinates: number[]
  }
  shape?: {
    type: string
    coordinates: number[][][]
  } | null
}

export interface IStationUserGoinZoneObject {
  id: string
  geojson: number[][][] | null
  coordinates: { lat: number; lng: number }
  radius: number
  name: string
  address: string
  description: string
  price: number
  type: StationUserGoinZoneShapeType | StationUserGeoJsonShapeType
  zoneType: StationUserGoinZoneType
  color: string
  mapObject: any | null
  pointType: string
  visible: boolean
}

export interface IStationUSerGoinzonesState {
  isFetching: boolean
  visible: boolean
  items: IMap<IStationUserZoneObject>
}



// WEBPACK FOOTER //
// ./src/types/station-user.ts